/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Short_Spry_Bee_AchieveInputs */

const fr_short_spry_bee_achieve = /** @type {(inputs: Short_Spry_Bee_AchieveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer programme`)
};

/**

* @param {Short_Spry_Bee_AchieveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const short_spry_bee_achieve = /** @type {((inputs?: Short_Spry_Bee_AchieveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Short_Spry_Bee_AchieveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_short_spry_bee_achieve(inputs)
});